@if (showOverlay()) {
<div class="overlay top-index">
    <div class="h-100 d-flex flex-column align-items-center justify-content-center position-absolute w-100 top-index">
        <div class="spinner-border spinner-border-white"
             role="status"></div>
    </div>
</div>
}
@if (!showOverlay()) {
<div class="h-100 d-flex flex-column align-items-center justify-content-center position-absolute w-100 top-index">
    <div class="spinner-border" role="status"></div>
</div>
}
